<template>
  <div>
    <header>
      <h3 class="float-left">付款完成</h3>
    </header>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="7" lg="6">
          <v-card class="thank-card">
            <v-card-text class="text-center">
              <v-icon color="success" size="72">mdi-check-circle</v-icon>
              <h2 class="mt-4 mb-3">感謝您的廣告刊登申請</h2>
              <div class="message">
                若付款結果已由綠界通知系統，廣告會依方案立即上線。若畫面剛完成導回但前台尚未出現，請稍候幾分鐘再重新整理。
              </div>
              <v-alert class="mt-5 text-left" outlined type="info" color="primary">
                此頁面是付款完成後的瀏覽器導回頁；實際上線仍以綠界背景通知 Server 的付款結果為準。
              </v-alert>
            </v-card-text>
            <v-card-actions class="justify-center pb-6">
              <v-btn color="primary" to="/">回首頁</v-btn>
              <v-btn text color="primary" to="/ads">再申請一筆</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "AdsThank",
};
</script>

<style lang="scss" scoped>
header {
  padding: 0 20px;
  height: 50px;
  line-height: 50px;
  background-color: #1976d2;
  color: #fff;
}
.thank-card {
  margin-top: 32px;
}
.message {
  color: #555;
  font-size: 16px;
  line-height: 1.8;
}
</style>
